import React, { useState, useEffect, useRef } from 'react';

const MultiplyByFiveGame = () => {
  const [currentNumber, setCurrentNumber] = useState(0);
  const [step1, setStep1] = useState('');
  const [step2, setStep2] = useState('');
  const [final, setFinal] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackClass, setFeedbackClass] = useState('');
  const [showNext, setShowNext] = useState(false);
  const containerRef = useRef(null);
  const correctSound = useRef(null);
  const wrongSound = useRef(null);

  useEffect(() => {
    generateQuestion();
  }, []);

  const generateQuestion = () => {
    const number = Math.floor(Math.random() * 20) + 1;
    setCurrentNumber(number);
    setStep1('');
    setStep2('');
    setFinal('');
    setFeedback('');
    setFeedbackClass('');
    setShowNext(false);
  };

  const createSparkle = (x, y) => {
    const sparkle = document.createElement('div');
    sparkle.style.position = 'absolute';
    sparkle.style.width = '12px';
    sparkle.style.height = '12px';
    sparkle.style.borderRadius = '50%';
    sparkle.style.backgroundColor = '#facc15';
    sparkle.style.left = `${x}px`;
    sparkle.style.top = `${y}px`;
    sparkle.style.pointerEvents = 'none';
    sparkle.style.animation = 'fadeMove 1.2s ease-out forwards';

    sparkle.style.opacity = '1';
    sparkle.style.transform = 'translateY(0px)';
    sparkle.style.transition = 'opacity 1.2s, transform 1.2s';
    setTimeout(() => {
      sparkle.style.opacity = '0';
      sparkle.style.transform = 'translateY(-40px)';
    }, 10);

    containerRef.current.appendChild(sparkle);
    setTimeout(() => sparkle.remove(), 1200);
  };

  const createMultipleSparkles = () => {
    const container = containerRef.current;
    for (let i = 0; i < 15; i++) {
      const x = Math.random() * container.clientWidth * 0.8 + container.clientWidth * 0.1;
      const y = Math.random() * container.clientHeight * 0.5 + container.clientHeight * 0.1;
      setTimeout(() => createSparkle(x, y), i * 80);
    }
  };

  const checkAnswer = () => {
    const s1 = parseFloat(step1);
    const s2 = parseFloat(step2);
    const f = parseFloat(final);
    const correctStep1 = currentNumber * 10;
    const correctStep2 = correctStep1 / 2;

    if (s1 === correctStep1 && s2 === correctStep2 && f === correctStep2) {
      setFeedback('✅ Correct! Great job!');
      setFeedbackClass('correct');
      correctSound.current.play();
      createMultipleSparkles();
      setShowNext(true);
    } else {
      setFeedback(`❌ Try again! Hint: 10 × ${currentNumber} = ${correctStep1}, Half = ${correctStep2}`);
      setFeedbackClass('incorrect');
      wrongSound.current.play();
    }
  };

  const feedbackStyle = {
    marginTop: '1rem',
    fontWeight: 'bold',
    color: feedbackClass === 'correct' ? 'green' : feedbackClass === 'incorrect' ? 'red' : 'black',
    minHeight: '2rem',
  };

  return (
    <div
      ref={containerRef}
      role="main"
      aria-live="polite"
      aria-atomic="true"
      style={{
        fontFamily: 'Segoe UI, sans-serif',
        backgroundColor: '#fef9c3',
        padding: '2rem',
        borderRadius: '12px',
        maxWidth: '400px',
        margin: '2rem auto',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        position: 'relative',
        textAlign: 'center',
      }}
    >
      <h1 style={{ color: '#eab308', marginBottom: '1rem' }}>Half of Ten!</h1>
      <p style={{ fontWeight: 'bold' }}>What is 5 × {currentNumber}?</p>
      <p>
        Step 1: 10 × ? ={' '}
        <input
          type="number"
          value={step1}
          onChange={(e) => setStep1(e.target.value)}
          aria-label="Step 1: multiply by 10"
          style={{
            padding: '0.5rem',
            width: '80px',
            margin: '0.5rem 0',
            borderRadius: '6px',
            border: '1px solid #ccc',
          }}
        />
      </p>
      <p>
        Step 2: Half ={' '}
        <input
          type="number"
          value={step2}
          onChange={(e) => setStep2(e.target.value)}
          aria-label="Step 2: half of step 1"
          style={{
            padding: '0.5rem',
            width: '80px',
            margin: '0.5rem 0',
            borderRadius: '6px',
            border: '1px solid #ccc',
          }}
        />
      </p>
      <p>
        Final Answer ={' '}
        <input
          type="number"
          value={final}
          onChange={(e) => setFinal(e.target.value)}
          aria-label="Final answer"
          style={{
            padding: '0.5rem',
            width: '80px',
            margin: '0.5rem 0',
            borderRadius: '6px',
            border: '1px solid #ccc',
          }}
        />
      </p>
      {!showNext && (
        <button
          onClick={checkAnswer}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#34d399',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            marginTop: '1rem',
          }}
          aria-describedby="feedback"
        >
          Check
        </button>
      )}
      <div id="feedback" role="alert" style={feedbackStyle}>
        {feedback}
      </div>
      {showNext && (
        <button
          onClick={generateQuestion}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#60a5fa',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            marginTop: '1rem',
          }}
        >
          Next Question
        </button>
      )}

      {/* Sound effects */}
      <audio ref={correctSound} src="https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg" preload="auto" />
      <audio ref={wrongSound} src="https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg" preload="auto" />
    </div>
  );
};

export default MultiplyByFiveGame;
